<template>
	<Layout>
		<div class="directory-container">
			<div class="container">
				<div class="navbar-group justify-space-between flex-wrap gap-2">
					<div class="d-flex align-center flex-wrap gap-2">
						<LeadModal />
						<v-btn
							variant="outlined"
							data-cy="reconnect-zoom-btn"
							@click="reconnectZoom"
						>
							Reconnect Zoom
						</v-btn>
					</div>

					<div style="flex-grow: 1; max-width: 100%; position: relative">
						<v-text-field
							style="width: 350px; max-width: 100%; margin-left: auto"
							class="custom-input"
							label="Search Leads"
							variant="outlined"
							bg-color="white"
							color="gray300"
							density="comfortable"
							v-model="state.search"
							clearable
							data-cy="lead-search-input"
						>
							<template #append-inner>
								<div class="d-flex align-center">
									<v-icon>mdi-magnify</v-icon>
									<v-menu
										location="bottom right"
										@update:model-value="state.showSelectionMenu = $event"
									>
										<template #activator="{ props }">
											<v-icon
												v-bind="props"
												class="ml-2"
												data-cy="lead-filter-menu"
											>
												mdi-menu-down
											</v-icon>
										</template>
										<v-list>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'leads'"
												value="leads"
												data-cy="lead-filter-leads"
												@click="state.filter = 'leads'"
											>
												Leads
											</v-list-item>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'trials'"
												value="trials"
												data-cy="lead-filter-trials"
												@click="state.filter = 'trials'"
											>
												Trials
											</v-list-item>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'converted'"
												value="converted"
												data-cy="lead-filter-converted"
												@click="state.filter = 'converted'"
											>
												Converted
											</v-list-item>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'suppressed'"
												value="suppressed"
												data-cy="lead-filter-suppressed"
												@click="state.filter = 'suppressed'"
											>
												Suppressed
											</v-list-item>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'all'"
												value="all"
												data-cy="lead-filter-all"
												@click="state.filter = 'all'"
											>
												All
											</v-list-item>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-text-field>
					</div>
				</div>
				<LeadsDirectory
					:search="state.search || ''"
					:filter="state.filter"
					@update:search="state.search = $event"
				/>
			</div>
		</div>
	</Layout>
</template>

<script setup lang="ts">
import Layout from "@/views/support/Layout.vue";
import LeadsDirectory from "@/components/support/LeadsDirectory.vue";
import LeadModal from "@/components/support/LeadModal.vue";
import { leadFilterFromQuery, leadFilterQueryParam } from "@/components/support/leadsUtils";
import { useZoomReconnect } from "@/composables/useZoomReconnect";
import { reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

const { reconnectZoom } = useZoomReconnect();

const route = useRoute();
const router = useRouter();

const state = reactive({
	search: "",
	showSelectionMenu: false,
	filter: leadFilterFromQuery(route.query.filter),
});

watch(
	() => state.filter,
	(filter) => {
		const query = { ...route.query };
		const next = leadFilterQueryParam(filter);
		if (next) query.filter = next;
		else delete query.filter;
		const current = route.query.filter || undefined;
		if (current === next) return;
		router.replace({ query });
	}
);

watch(
	() => route.query.filter,
	(filter) => {
		state.filter = leadFilterFromQuery(filter);
	}
);
</script>

<style scoped lang="scss">
.directory-container {
	padding: 20px 30px 0;
}
</style>
